import { createIcon } from "../icon-factory";

export const SalesforceIcon = createIcon(
  <path
    fill="#0D9DDA"
    fill-rule="nonzero"
    d="M6.24209 1.09312C6.7278 0.614648 7.39944 0.316526 8.14318 0.316526C9.13357 0.316526 9.99873 0.842842 10.4579 1.62311C10.8563 1.45381 11.3003 1.35812 11.767 1.35812C13.5543 1.35812 15 2.74936 15 4.46448C15 6.17961 13.5505 7.57085 11.767 7.57085C11.5469 7.57085 11.3344 7.54877 11.1295 7.51196C10.7235 8.20022 9.9532 8.66397 9.06527 8.66397C8.6934 8.66397 8.3443 8.583 8.03314 8.43577C7.62332 9.35591 6.66709 10 5.55148 10C4.43587 10 3.39995 9.3007 3.02049 8.318C2.85353 8.35112 2.68277 8.36952 2.50443 8.36952C1.1232 8.36952 0 7.29113 0 5.95878C0 5.06809 0.50468 4.28782 1.25221 3.87192C1.09664 3.53331 1.01315 3.16158 1.01315 2.77144C1.01315 1.24034 2.31849 0 3.9274 0C4.87225 0 5.71085 0.430621 6.24209 1.09312Z"
  />,
  "0 0 15 10"
);
